(function () {
  var root = document.getElementById('ce-up-popup');
  if (!root || root.getAttribute('data-init')) return;
  root.setAttribute('data-init', '1');
  var KEY = 'ce_popup_v1', CODE = 'WELCOME15', FORCE = /[?&]ce_popup=1/.test(location.search);
  var form = root.querySelector('form'), input = root.querySelector('#ceu-p-email'), err = root.querySelector('#ceu-p-err');
  var submit = root.querySelector('[data-ceup-submit]'), lastFocus = null, fired = false, timer = null;
  function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return false; } }
  function mark(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function consentOpen() { return document.documentElement.hasAttribute('data-ce-consent-open'); }
  function cartOpen() { var d = document.getElementById('CartDrawer'); return !!(d && d.hasAttribute('open')); }
  function canShow() {
    if (!FORCE && seen()) return false;
    if (/\/(cart|checkout)/.test(location.pathname)) return false;
    return true;
  }
  function focusables() { return root.querySelectorAll('button:not([hidden]):not([disabled]),a[href],input'); }
  function open() {
    if (fired || !canShow()) return;
    if (cartOpen()) { setTimeout(open, 4000); return; }
    if (consentOpen()) { document.addEventListener('ce-consent-closed', function () { setTimeout(open, 1500); }, { once: true }); return; }
    fired = true; mark('shown'); lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('ceu-p-lock');
    window.requestAnimationFrame(function () { root.setAttribute('data-state', 'open'); root.querySelector('.ceu-p__title').focus({ preventScroll: true }); });
  }
  function close() {
    root.setAttribute('data-state', 'closed'); root.hidden = true; document.documentElement.classList.remove('ceu-p-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }
  function trigger() {
    if (fired || timer === 'done') return;
    timer = 'done'; open();
  }
  setTimeout(trigger, FORCE ? 500 : 12000);
  window.addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= 0.4) trigger();
  }, { passive: true });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ceup]'); if (!b) return;
    var a = b.getAttribute('data-ceup');
    if (a === 'close') close();
    else if (a === 'copy') {
      var done = function () { b.textContent = 'Kopiert'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, done); else done();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === root.querySelector('.ceu-p__title'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  function fail(msg) { err.textContent = msg; input.setAttribute('aria-invalid', 'true'); submit.disabled = false; submit.textContent = 'Gutschein sichern'; }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    err.textContent = ''; input.removeAttribute('aria-invalid');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail('Bitte geben Sie eine gültige E-Mail-Adresse ein.'); input.focus(); return; }
    submit.disabled = true; submit.textContent = 'Wird gesendet …';
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var body = { data: { type: 'subscription',
      attributes: { custom_source: "Popup 15 € (Cat's Empire) l " + (mobile ? 'MOBILE' : 'Desktop'),
        profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { list: { data: { type: 'list', id: 'YnU7kD' } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=R8uAj3', {
      method: 'POST', headers: { revision: '2024-10-15', 'content-type': 'application/vnd.api+json' }, body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 202 || r.status === 200 || r.status === 204) {
        mark('subscribed');
        root.querySelector('[data-ceup-form]').hidden = true; root.querySelector('[data-ceup-done]').hidden = false;
        root.querySelector('[data-ceup-note]').hidden = true; root.querySelector('[data-ceup-codebox]').hidden = false;
        root.querySelector('.ceu-p__title').textContent = 'Ihr Gutschein ist da';
        root.querySelector('.ceu-p__title').focus({ preventScroll: true });
      } else if (r.status === 400) { fail('Diese E-Mail-Adresse wurde nicht akzeptiert. Bitte prüfen Sie die Eingabe.'); }
      else { fail('Das hat gerade nicht geklappt. Bitte versuchen Sie es gleich noch einmal.'); }
    }).catch(function () { fail('Keine Verbindung. Bitte prüfen Sie Ihr Netz und versuchen Sie es erneut.'); });
  });
  /* Klaviyo-Formular XmBUZv in dieser Theme-Kopie unterdruecken */
  function hideKl() {
    var n = document.querySelectorAll('[class*="XmBUZv"],[data-testid*="XmBUZv"],[data-form-id="XmBUZv"]');
    for (var i = 0; i < n.length; i++) { var w = n[i].closest('.kl-private-reset-css-Xuajs1,[aria-modal],.needsclick') || n[i]; w.classList.add('ceu-kl-hide'); }
  }
  hideKl();
  if (window.MutationObserver) new MutationObserver(hideKl).observe(document.body, { childList: true, subtree: true });
})();
